import { useCallback } from 'react'

import { apiManager, constants } from 'helpers'
import useAuthDispatch from './useAuthDispatch'

const {
  AUTH_ACTIONS: { LOGIN, PARTIAL_UPDATE_USER },
} = constants

const useUpdateUser = () => {
  const dispatch = useAuthDispatch()

  const update = useCallback(
    async data => {
      const response = await apiManager.updateUserSettings(data)
      dispatch({ type: LOGIN, payload: response })
      return response
    },
    [dispatch]
  )

  const updateUserData = useCallback(
    async payload => {
      dispatch({ type: PARTIAL_UPDATE_USER, payload })
    },
    [dispatch]
  )

  const reload = useCallback(async () => {
    const response = await apiManager.getMe()
    dispatch({ type: LOGIN, payload: response })
    return response
  }, [dispatch])

  return { update, updateUserData, reload }
}

export default useUpdateUser
